import { RootState } from '../store';
import { Pathname } from 'history';

export const selectPathname = (state: RootState): Pathname => state.router.location.pathname;
